import type { SceneObject } from 'trace-viewer/scene';
import type { TrackBuildObject } from 'trace-viewer/build';
import type { ToolContext } from './agent-helpers';

/** Track synchronous allocations before a load yields, then its returned root. */
export async function trackImport<T>(
    ctx: ToolContext, track: TrackBuildObject | undefined, load: () => Promise<T>, root: (result: T) => SceneObject,
): Promise<T> {
    const before = new Set(ctx.traceScene.getSceneObjects());
    let pending: Promise<T>;
    try { pending = load(); }
    finally {
        for (const object of ctx.traceScene.getSceneObjects()) if (!before.has(object)) track?.(object);
    }
    const result = await pending;
    track?.(root(result));
    return result;
}
